module.exports = __webpack_public_path__ + "img/1402672340.cf33a3e6.jpg";